import React, { useState } from "react";
import logo from '../img/logo.png';


const Header = () => {
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  return (
    <header>
      <a href='/' className='logo'>
        <img
        alt="logo"
          src={logo}
          style={{ height: '50px', width: '50px', opacity: '0.7' }}
        />
      </a>
      <div >
      <button className='bx bx-menu' id='menu-icon' onClick={() => {
          setIsNavExpanded(!isNavExpanded);
        }}>
        {/* icon from heroicons.com */}
       
      </button>
      </div>
      <div
        className={
          isNavExpanded ? "navigation-menu expanded" : "navbar"
        }>

      <ul className='navbar'>
        <li>
          <a href='#home'>Home</a>
        </li> 
        <li>
          <a href='#about'>About Me</a>
        </li>
        <label>
          <a href="#education"> Education</a>
        </label>
        <li>
          <a href='#services'>Services</a>
        </li>
        <li>
          <a href='#portfolio'>My Portfolio</a>
        </li>
        <li>
          <a href='#contact'>Contact</a>
        </li>
      </ul>
      </div>
    </header>
  );
};

export default Header;